<!-- topic -->
<template>
  <div class="topic">
    <el-form :model="ruleForm" label-width="160px">
      <el-form-item label="论文主题：" prop="topic">
        <el-input v-model="ruleForm.topic" type="text" class="fl" style="width: 50%;" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'topic',
  data() {
    return {}
  },
  props: {
    ruleForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {},
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>
